import _ from 'underscore';
import { IReturnProductHotelOffer } from '@ve/pages/hotel/types';
import { IHotelOfferTariff } from '@ve/components/hotel/hotelOffersTariffsPopup/common/types';

export default (hotelOffers: IReturnProductHotelOffer[]): IHotelOfferTariff[] => _.map(hotelOffers, (hotelOffer) => ({
    tourId: hotelOffer.id,
    price: hotelOffer.price,
    roomName: hotelOffer.room.name,
    cancellationPolicy: hotelOffer.cancellationPolicy,
}));
